module.exports = __webpack_public_path__ + "static/img/room2.b43a739.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/room2.jpg
// module id = 2QTS
// module chunks = 0